import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class IpoOtpLeadUsecase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getIpoOtpLeads(req);
    }
}
export default IpoOtpLeadUsecase;
